import { useMutation } from 'react-query';
import { network } from 'services/network';

const uploadDocumentFile = (file: File) => {
    const data = new FormData();
    // console.log(file);
    data.append('file', file);

    const payload: any = {};

    return network
        .post('api/bo/uploadCardAssociatedDocument', data, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((data) => {
            return data;
        });
};

export const useMutationUploadDocumentFile = () => {
    return useMutation<any, QueryError, UploadDocumentPayload>({
        mutationFn: uploadDocumentFile,
    });
};

export type UploadDocumentPayload = File;

export interface mutationResponse {
    id: number;
    path: string;
    name: string;
}
